import * as React from 'react';
import './form-field-divider.css';

export default class FormFieldDivider extends React.Component<{}, {}> {
  render(): JSX.Element {
    return <div className="form-field-divider" />;
  }
}
